module.exports = __webpack_public_path__ + "img/re-cpo-small.54117c9d.png";